/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Track_ForInputs */

const en_cp_track_for = /** @type {(inputs: Cp_Track_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good for`)
};

const id_cp_track_for = /** @type {(inputs: Cp_Track_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cocok untuk`)
};

/**
* | output |
* | --- |
* | "Good for" |
*
* @param {Cp_Track_ForInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_track_for = /** @type {((inputs?: Cp_Track_ForInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Track_ForInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_track_for(inputs)
	return en_cp_track_for(inputs)
});